export const PATH = {
  LOGIN: "/auth",
  SIGN_UP: "/signup",
  RESET_PASSWORD: "/reset-password",
  HOME: "/dashboard",
  APPLICATIONS: "/applications",
  PROJECTS: "/projects",
  DEPLOY: "/deploy",
  CREATE_DEPLOY: "/create-deploy",
  GITHUB: "/github",
};

export const API_V1 = {
  ACTIVITY: "/v1/activity",
  ALERTS: "/v1/alerts",
  DEPLOY: "/v1/deploy",
  APPLICATIONS: "/v1/applications",
  USER: "/v1/user",
};

export const APPLICATION_CATEGORY = {
  APPLICATIONS: "applications",
  STATIC_SITES: "static_sites",
  DATABASES: "databases",
} as const;

export const DEPLOY_STATUS = {
  NEW: "new",
  IN_PROGRESS: "in_progress",
  FAILED: "failed",
  COMPLETE: "complete",
  DELETING: "deleting",
  DELETED: "deleted",
};

export const DOMAIN_STATUS = {
  ACTIVE: "active",
  PENDING: "pending",
  ERROR: "error",
};
